import React, { useState, useRef, useEffect } from "react";
import Recorder from "../components/Recorder";
import EmotionResultBox from "../components/EmotionDisplay";
import "./Home.css";
import { Link } from "react-router-dom";
import XiAssistant from "../components/assistant/XiAssistant";
import { sendVoiceToSpeechBot } from "../components/api";
import { useNavigate, useLocation } from "react-router-dom";
import LoginModal from "./Login";
import { deleteUserById } from "../components/api";
import SubscriptionModal from '../components/SubscriptionModal';
import { PLANS, DOCTOR_PLANS, CORPORATE_PLANS, SCHOOL_PLANS, SPORTS_PLANS } from '../components/PricingSection';
import HelpDropdown from '../components/HelpDropdown';
import ConsultModal from '../components/ConsultModal';
import useTranslation from '../hooks/useTranslation';
import useUserRole from '../hooks/useUserRole';
import useInviteListener from '../hooks/useInviteListener';
import XiTopNav from '../components/xi/XiTopNav';
import XiBottomNav from '../components/xi/XiBottomNav';
import XiBackdrop from '../components/xi/XiBackdrop';
import XiMascot from '../components/xi/XiMascot';
import XiBotAvatar from '../components/xi/XiBotAvatar';
import UserDetailsModal from '../components/UserDetailsModal';
import DeleteAccountModal from '../components/DeleteAccountModal';
import ResetPasswordModal from '../components/ResetPasswordModal';
import SchoolUniversityHome from './SchoolUniversityHome';
import HospitalDashboard from './HospitalDashboard';
import HospitalDoctorDashboard from './Hospital_DoctorDashboard';
import CorporateDashboard from './CorporateDashboard';
import DoctorDashboard from './DoctorDashboard';
import TakeCareAgencyDashboard from './TakeCareAgencyDashboard';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { motion, AnimatePresence } from "framer-motion";
import { LuAudioLines, LuMessageCircle, LuArrowRight, LuChartColumn, LuBrainCircuit, LuFlower2, LuTrendingUp, LuHand, LuStethoscope, LuBluetooth } from 'react-icons/lu';
import RingPairingModal from '../components/RingPairingModal';
import RingAudioHandler from '../components/RingAudioHandler';
import { authFetch, authHeaders } from '../utils/authFetch';


const shouldAutoOpenBot = () => {
  if (sessionStorage.getItem("neuro_bot_shown") === "true") return false;
  sessionStorage.setItem("neuro_bot_shown", "true");
  return true;
};

const API_HOST = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8000'
  : 'https://app.neurolonic.com/api';

function LoaderOverlay() {
  return (
    <div className="loader-overlay-gif">
      <div className="loader-lottie-container">
        <DotLottieReact
          src="https://lottie.host/137c3f68-7f71-4e2a-96c0-47a9a07c302c/0vmeyxWRaL.lottie"
          loop
          autoplay
          style={{ width: '200px', height: '200px' }}
        />
      </div>
      <div className="loader-message">Analyzing your voice... <br /> Please wait</div>
    </div>
  );
}

export default function Home({ onSerialConnected, onRingPaired, onRingUnpaired } = {}) {
  const location = useLocation();
  const recorderStartRef = useRef(null);
  const navigate = useNavigate();

  const [emotionResult, setEmotionResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const reportRef = useRef(null);
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);

  const [showRingModal, setShowRingModal] = useState(false);
  const [ringPaired, setRingPaired] = useState(false);
  const [, setRingId] = useState(null);
  const [serialPort, setSerialPort] = useState(null);
  const [bleDevice, setBleDevice] = useState(null);
  const [bleConnectKey, setBleConnectKey] = useState(0);

  const [, setBotModalOpen] = useState(false);
  const [botLoading, setBotLoading] = useState(false);
  const [, setBotReplyAudio] = useState(null);
  const [, setBotReplyText] = useState("");
  const [botContext, setBotContext] = useState("");
  const [recording, setRecording] = useState(false);
  const [, setIntroPlaying] = useState(false);
  const [, setShowInviteBtn] = useState(false);

  const [showConsultModal, setShowConsultModal] = useState(false);
  const [consultSuccessMsg, setConsultSuccessMsg] = useState('');

  const hasTriggeredIntro = useRef(false);
  const mediaRecorder = useRef(null);
  const audioChunks = useRef([]);

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [userDetailsModalOpen, setUserDetailsModalOpen] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [loginRedirectMsg, setLoginRedirectMsg] = useState("");
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [startSignal, setStartSignal] = useState(0);

  const [userName, setUserName] = useState(() => localStorage.getItem("neuro_user_name"));
  const [userId, setUserId] = useState(() => localStorage.getItem("neuro_user_id"));

  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileProfileOpen, setMobileProfileOpen] = useState(false);
  const [mobileLanguageOpen, setMobileLanguageOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isLoadingUserDetails, setIsLoadingUserDetails] = useState(false);

  // Extracted hooks
  const roles = useUserRole(userDetails);
  const { inviteInfo, dismissInvite } = useInviteListener(userId);

  const {
    isSchoolAdmin, isHospitalAdmin, isCorporateAdmin,
    isDoctor, isHospitalDoctor, isTakeCareAgency
  } = roles;

  useEffect(() => {
    if (!userId) return;
    const verifyUserExists = async () => {
      try {
        const base = process.env.REACT_APP_API_URL || "/api";
        const res = await authFetch(`${base}/user/details?user_id=${userId}`, { headers: authHeaders() });
        const data = await res.json();
        if (!data || !data.data || data.status_code === 404) {
          localStorage.clear();
          window.location.href = "/";
        }
      } catch (e) {
        console.warn('verifyUserExists: network error, keeping session', e);
      }
    };
    verifyUserExists();
  }, [userId]);

  useEffect(() => {
    try {
      const path = (location && location.pathname ? location.pathname : '').toLowerCase();
      if (userId && (path === '/getstarted' || path === '/getstarted/' || path === '/getstarted#' || path === '/getstarted?' || path === '/getstarted%20' || path === '/getstarted%20/' || path === '/getstarted%20#' || path === '/getstarted%20?' || path === '/getstarted%20%20' || path === '/getstarted%20%20/' || path === '/getstarted%20%20#' || path === '/getstarted%20%20?' || path === '/getstarted%20%20%20' || path === '/getstarted%20%20%20/' || path === '/getstarted%20%20%20#' || path === '/getstarted%20%20%20?' || path === '/getstarted%20%20%20%20' || path === '/getstarted%20%20%20%20/' || path === '/getstarted%20%20%20%20#' || path === '/getstarted%20%20%20%20?'
        || path === '/getstarted' || path === '/getstarted/' || path === '/getstarted#' || path === '/getstarted?'
        || path === '/getstarted' || path === '/getstarted/'
        || path === '/getstarted' || path === '/gets' || path === '/getstarted' || path === '/getstarted' || path.endsWith('/gets'))) {
        navigate('/', { replace: true });
      }
    } catch { /* navigate should not throw, but guard against edge cases */ }
  }, [userId, location, navigate]);

  useEffect(() => {
    function syncUser() {
      setUserName(localStorage.getItem("neuro_user_name"));
      setUserId(localStorage.getItem("neuro_user_id"));
    }
    window.addEventListener("storage", syncUser);
    syncUser();
    return () => window.removeEventListener("storage", syncUser);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get('email');
    if (!emailParam) return;
    const currentUserEmail = userName || localStorage.getItem("neuro_user_name");
    const currentUserId = userId || localStorage.getItem("neuro_user_id");
    const emailMatches = currentUserEmail && currentUserEmail.toLowerCase() === emailParam.toLowerCase();
    if (!currentUserId || !emailMatches) {
      if (currentUserId && !emailMatches) {
        localStorage.removeItem("neuro_user_id");
        localStorage.removeItem("neuro_user_name");
        localStorage.removeItem("neuro_user_role");
        setUserId(null);
        setUserName(null);
      }
      setShowLoginModal(true);
      setTimeout(() => {
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
      }, 100);
    } else {
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [userId, userName]);

  useEffect(() => {
    async function fetchUserDetailsFallback() {
      try {
        let url = null;
        const base = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:8000' : 'https://app.neurolonic.com/api');
        if (userId) {
          url = `${base}/user/details?user_id=${userId}`;
        } else if (userName) {
          url = `${base}/user/details?user_name=${encodeURIComponent(userName)}`;
        }
        if (url) {
          const res = await authFetch(url, { headers: authHeaders() });
          const data = await res.json();
          if (data && data.data) {
            setUserDetails(data.data);
            if (data.data.role === "Doctor" && data.data.info) {
              try {
                const info = typeof data.data.info === 'string' ? JSON.parse(data.data.info) : data.data.info;
                if (info && info.hospital_id) {
                  localStorage.setItem("neuro_is_hospital_doctor", "true");
                  localStorage.setItem("neuro_user_info", JSON.stringify(data.data.info));
                } else {
                  localStorage.setItem("neuro_is_hospital_doctor", "false");
                }
              } catch (e) {
                console.error('Error parsing user info in Home.jsx:', e);
              }
            }
            return;
          }
        }
      } catch (e) {
        console.warn('fetchUserDetailsFallback failed:', e);
      }
      setUserDetails(null);
    }
    if (userDetailsModalOpen) {
      fetchUserDetailsFallback();
    }
  }, [userDetailsModalOpen, userId, userName]);

  function handleLoginSuccess() {
    setShowLoginModal(false);
    window.location.reload();
  }

  function speakBotText(text) {
    if (!text || typeof window === 'undefined' || !window.speechSynthesis) return false;
    try {
      window.speechSynthesis.cancel();
      const utter = new SpeechSynthesisUtterance(text);
      utter.lang = 'en-US';
      utter.pitch = 1.2;
      utter.rate = 1.05;
      const pickVoice = () => {
        const voices = window.speechSynthesis.getVoices();
        const female =
          voices.find(v => v.name.toLowerCase().includes('female')) ||
          voices.find(v => v.name.includes('Google UK English Female')) ||
          voices.find(v => /english/i.test(v.lang || ''));
        if (female) utter.voice = female;
      };
      utter.onstart = () => setIntroPlaying(true);
      utter.onend = () => setIntroPlaying(false);
      utter.onerror = () => setIntroPlaying(false);
      if (window.speechSynthesis.getVoices().length === 0) {
        window.speechSynthesis.onvoiceschanged = () => {
          pickVoice();
          window.speechSynthesis.speak(utter);
          window.speechSynthesis.onvoiceschanged = null;
        };
      } else {
        pickVoice();
        window.speechSynthesis.speak(utter);
      }
      return true;
    } catch {
      setIntroPlaying(false);
      return false;
    }
  }

  async function handleSpeechBotRecord() {
    console.log("Speech bot record triggered, current state:", { recording, botLoading });
    if (!recording) {
      console.log("Starting speech bot recording...");
      try {
        if (typeof window !== 'undefined' && window.speechSynthesis) {
          window.speechSynthesis.cancel();
        }
      } catch { }
      setIntroPlaying(false);
      setBotReplyText("");
      setBotReplyAudio(null);
      setRecording(true);
      audioChunks.current = [];

      navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
        console.log("Microphone access granted, creating MediaRecorder");
        mediaRecorder.current = new window.MediaRecorder(stream);
        mediaRecorder.current.ondataavailable = (e) => {
          console.log("Audio data available, size:", e.data.size, "bytes");
          if (e.data.size > 0) audioChunks.current.push(e.data);
        };
        mediaRecorder.current.onstop = async () => {
          console.log("Recording stopped, processing audio...");
          setRecording(false);
          setBotLoading(true);
          const blob = new Blob(audioChunks.current, { type: "audio/ogg" });
          console.log("Audio blob created, size:", blob.size, "bytes");
          try {
            console.log("Sending audio to speech bot API...");
            const data = await sendVoiceToSpeechBot(blob, { context: botContext });
            console.log("Speech bot response received:", data);
            const replyText =
              (typeof data.response === 'string' && data.response.trim())
                ? data.response
                : (typeof data.message === 'string' ? data.message : "No reply text.");
            setBotReplyText(replyText);
            setBotContext(data.context || botContext);
            if (data.audio_base64) {
              console.log("Processing bot audio response...");
              const b64 = data.audio_base64 || "";
              if (typeof b64 === "string" && b64.startsWith("data:")) {
                setBotReplyAudio(b64);
              } else {
                try {
                  const binary = atob(b64);
                  const len = binary.length;
                  const bytes = new Uint8Array(len);
                  for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
                  const audioBlob = new Blob([bytes], { type: "audio/mpeg" });
                  setBotReplyAudio(URL.createObjectURL(audioBlob));
                } catch (e) {
                  console.warn("Failed to decode bot audio base64");
                  setBotReplyAudio(null);
                }
              }
            } else if (replyText) {
              speakBotText(replyText);
            }
          } catch (e) {
            console.error("Speech bot API error:", e);
            setBotReplyText("Bot failed to respond.");
          }
          setBotLoading(false);
        };
        mediaRecorder.current.start();
        console.log("MediaRecorder started successfully");
      }).catch(err => {
        console.error("Microphone access denied:", err);
        setRecording(false);
      });
    } else {
      console.log("Stopping speech bot recording...");
      if (mediaRecorder.current && mediaRecorder.current.state === "recording") {
        mediaRecorder.current.stop();
      }
    }
  }

  /**
   * Real assistant contract for the Xi panel.
   * Reuses the existing `sendVoiceToSpeechBot` endpoint and the existing
   * botLoading / botContext / botReplyText state. Never fabricates a reply.
   */
  async function assistantSendVoice(blob) {
    setBotLoading(true);
    try {
      const data = await sendVoiceToSpeechBot(blob, { context: botContext });
      const replyText =
        (typeof data?.response === 'string' && data.response.trim())
          ? data.response
          : (typeof data?.message === 'string' ? data.message : '');
      setBotReplyText(replyText || 'No reply text.');
      setBotContext(data?.context || botContext);
      if (data?.audio_base64) {
        try {
          const src = String(data.audio_base64).startsWith('data:')
            ? data.audio_base64
            : `data:audio/mpeg;base64,${data.audio_base64}`;
          const audio = new Audio(src);
          audio.play().catch(() => {});
        } catch { /* ignore playback failures */ }
      } else if (replyText) {
        speakBotText(replyText);
      }
      return { text: replyText || 'No reply text.' };
    } finally {
      setBotLoading(false);
    }
  }

  function parseSub(str) {
    if (!str) return [];
    const lines = str.split("\n").filter(Boolean);
    const result = [];
    lines.forEach((line) => {
      const match = line.match(/: (.+)$/);
      if (match) result.push({ label: match[1], value: 80 });
    });
    return result;
  }
  function parseApiResult(apiRes) {
    let top5 = [];
    if (apiRes.top_5) {
      top5 = apiRes.top_5.split(",").map((str) => {
        const [label, percent] = str.trim().split(" ");
        return {
          label: label.charAt(0).toUpperCase() + label.slice(1),
          value: Number(percent.replace("%", "")),
        };
      });
    }
    return {
      ...apiRes,
      top5,
      sub1: parseSub(apiRes.sub_1),
      sub2: parseSub(apiRes.sub_2),
    };
  }

  function handleApiResult(apiData) {
    console.log("API result received:", apiData);
    setLoading(false);
    if (apiData && apiData.RES) {
      const parsedResult = parseApiResult(apiData.RES);
      console.log("Parsed emotion result:", parsedResult);
      setEmotionResult(parsedResult);
      setShowSaveSuccess(false);
      setTimeout(() => {
        try { reportRef.current && reportRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch { }
      }, 50);
    } else {
      console.warn("Unexpected API response format:", apiData);
    }
  }

  function handleRecordingStart() {
    console.log("Emotion analysis recording started");
    setLoading(true);
    setEmotionResult(null);
  }

  function handleBotCommand(command) {
    console.log("Voice command received:", command);
    const cmd = command.toLowerCase();
    if (cmd.includes("dashboard")) {
      window.location.href = "/dashboard";
    } else if (cmd.includes("login")) {
      setShowLoginModal(true);
    } else if (cmd.includes("sign up") || cmd.includes("signup")) {
      window.location.href = "/getstarted";
    } else if (cmd.includes("get started")) {
      window.location.href = "/getstarted";
    } else if (cmd.includes("upload")) {
      document.querySelector('.upload-file-btn input[type="file"]')?.click();
    } else if (cmd.includes("analyze")) {
      setEmotionResult(null);
    } else if (cmd.includes("record")) {
      handleSpeechBotRecord();
    } else if (cmd.includes("speech bot") || cmd.includes("open model") || cmd.includes("talk to bot")) {
      setBotModalOpen(true);
    }
  }

  function handleLogout() {
    if (window.confirm("Are you sure?")) {
      const displayName = localStorage.getItem('neuro_display_name');
      localStorage.clear();
      if (displayName) {
        try { localStorage.setItem('neuro_display_name', displayName); } catch { }
      }
      window.location.href = "/";
    }
  }

  async function handleDeleteAccount() {
    try {
      let intUserId = userId;
      if (isNaN(Number(userId)) && userName) {
        const res = await authFetch(`${API_HOST}/user/details?user_name=${encodeURIComponent(userName)}`, { headers: authHeaders() });
        const data = await res.json();
        if (data && data.data && data.data.user_id) {
          intUserId = data.data.user_id;
        }
      }
      if (!intUserId) return;
      await deleteUserById(intUserId);
      localStorage.clear();
      setShowDeleteModal(false);
      setUserDetailsModalOpen(false);
      window.location.href = "/";
    } catch (e) {
      alert("Failed to delete account. Please try again.");
    }
  }

  function getFirstPlanForRole(role) {
    const roleKey = (role || '').toLowerCase();
    if (roleKey.includes('doctor')) return DOCTOR_PLANS[0];
    if (roleKey.includes('corporate')) return CORPORATE_PLANS[0];
    if (roleKey.includes('school')) return SCHOOL_PLANS[0];
    if (roleKey.includes('sport')) return SPORTS_PLANS[0];
    return PLANS[0];
  }

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 768);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!mobileMenuOpen) return;
    function handleClick(e) {
      if (!e.target.closest('.mobile-menu-dropdown') && !e.target.closest('.mobile-menu-btn')) {
        setMobileMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [mobileMenuOpen]);

  useEffect(() => {
    if (!isMobile) return;
    function handleClick(e) {
      if (mobileProfileOpen || mobileLanguageOpen) {
        if (!e.target.closest('.mobile-profile-dropdown') && !e.target.closest('.mobile-language-dropdown')) {
          setMobileProfileOpen(false);
          setMobileLanguageOpen(false);
        }
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isMobile, mobileProfileOpen, mobileLanguageOpen]);

  useEffect(() => {
    if (userId && isTakeCareAgency && location.pathname !== '/dashboard/take-care-agency') {
      navigate('/dashboard/take-care-agency');
    }
  }, [userId, isTakeCareAgency, navigate, location.pathname]);

  useEffect(() => {
    async function fetchUserDetailsOnMount() {
      const quickRole = localStorage.getItem('neuro_user_role');
      if (quickRole && (quickRole === 'Doctor' || quickRole === 'TakeCareAgency')) {
        return;
      }
      if (userId && !userDetails) {
        setIsLoadingUserDetails(true);
        try {
          let url = null;
          if (userName) {
            url = `${API_HOST}/user/details?user_name=${encodeURIComponent(userName)}`;
          } else if (userId) {
            url = `${API_HOST}/user/details?user_id=${userId}`;
          }
          if (url) {
            const res = await authFetch(url, { headers: authHeaders() });
            const data = await res.json();
            if (data && data.data) {
              setUserDetails(data.data);
              if (data.data.role === "Doctor" && data.data.info) {
                try {
                  const info = typeof data.data.info === 'string' ? JSON.parse(data.data.info) : data.data.info;
                  if (info && info.hospital_id) {
                    localStorage.setItem("neuro_is_hospital_doctor", "true");
                    localStorage.setItem("neuro_user_info", JSON.stringify(data.data.info));
                  } else {
                    localStorage.setItem("neuro_is_hospital_doctor", "false");
                  }
                } catch (e) {
                  console.error('Error parsing user info in Home.jsx:', e);
                }
              }
              return;
            }
          }
        } catch (e) {
          console.log('Failed to fetch user details on mount:', e);
        }
      }
      setIsLoadingUserDetails(false);
    }
    fetchUserDetailsOnMount();
  }, [userId, userName, userDetails]);

  useEffect(() => {
    if (!shouldAutoOpenBot()) return;
    if (!userId) {
      const greeting = "Hey welcome to Neurolonic, please login to explore more";
      setBotModalOpen(true);
      setBotReplyText("");
      setShowInviteBtn(true);
      async function playWithOpenAITTS() {
        try {
          const apiKey = process.env.OPENAI_API_KEY;
          if (!apiKey) throw new Error('Missing OPENAI_API_KEY');
          const res = await fetch('https://api.openai.com/v1/audio/speech', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${apiKey}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({ model: 'gpt-4o-mini-tts', voice: 'shimmer', input: greeting })
          });
          if (!res.ok) throw new Error('OpenAI TTS failed');
          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          const audioEl = document.getElementById('welcome-audio');
          if (!audioEl) throw new Error('welcome-audio element not found');
          audioEl.src = url;
          await audioEl.play();
          setTimeout(() => { try { audioEl.muted = false; audioEl.currentTime = 0; audioEl.play().catch(() => { }); } catch { } }, 300);
          audioEl.onplay = () => { setIntroPlaying(true); hasTriggeredIntro.current = true; setShowInviteBtn(false); };
          audioEl.onended = () => setIntroPlaying(false);
          audioEl.onerror = () => setIntroPlaying(false);
          return;
        } catch (e) {
          if (typeof window !== 'undefined' && window.speechSynthesis) {
            window.speechSynthesis.cancel();
            const utter = new SpeechSynthesisUtterance(greeting);
            utter.lang = 'en-US';
            utter.pitch = 1.4;
            utter.rate = 1.1;
            const voices = window.speechSynthesis.getVoices();
            const female = voices.find(v => v.name.includes('Google UK English Female')) || voices.find(v => v.name.toLowerCase().includes('female'));
            if (female) utter.voice = female;
            utter.onstart = () => { setIntroPlaying(true); hasTriggeredIntro.current = true; setShowInviteBtn(false); };
            utter.onend = () => setIntroPlaying(false);
            utter.onerror = () => setIntroPlaying(false);
            window.speechSynthesis.speak(utter);
          }
        }
      }
      playWithOpenAITTS();
    } else {
      let display = (localStorage.getItem('neuro_display_name') || userName || '').trim();
      if (display.includes('@')) {
        display = display.split('@')[0];
      }
      const greeting = `Hey ${display}! how are you today?`;
      setBotModalOpen(true);
      setBotReplyText(greeting);
      setShowInviteBtn(false);
      try {
        const audioEl = document.getElementById('welcome-audio');
        if (audioEl) {
          audioEl.pause();
          audioEl.currentTime = 0;
          audioEl.src = '';
        }
      } catch { /* ignore */ }
      if (typeof window !== 'undefined' && window.speechSynthesis) {
        try {
          window.speechSynthesis.cancel();
          const utter = new SpeechSynthesisUtterance(greeting);
          utter.lang = 'en-US';
          utter.pitch = 1.2;
          utter.rate = 0.9;
          let spoke = false;
          const speakGreeting = () => {
            if (spoke) return;
            spoke = true;
            utter.onstart = () => setIntroPlaying(true);
            utter.onend = () => setIntroPlaying(false);
            utter.onerror = () => setIntroPlaying(false);
            window.speechSynthesis.speak(utter);
          };
          const applyFemaleVoice = () => {
            const voices = window.speechSynthesis.getVoices() || [];
            const femaleVoice =
              voices.find(v => /female|woman|girl|samantha|victoria|allison|ava|joanna|nicole|mia|olivia|luna|ivy|clara|amy|scarlett|linda|susan|kendra|fiona|zoe|nicky|cora|aria|hannah|sarah|emma|olga|sophia/i.test(`${v.name} ${v.voiceURI}`)) ||
              voices.find(v => /en/i.test(v.lang || '') && !/male|man|boy|guy/i.test(`${v.name} ${v.voiceURI}`));
            if (femaleVoice) {
              utter.voice = femaleVoice;
            }
          };
          applyFemaleVoice();
          if (utter.voice) {
            speakGreeting();
          } else {
            const handleVoices = () => {
              applyFemaleVoice();
              speakGreeting();
              window.speechSynthesis.removeEventListener('voiceschanged', handleVoices);
            };
            window.speechSynthesis.addEventListener('voiceschanged', handleVoices);
            setTimeout(() => {
              window.speechSynthesis.removeEventListener('voiceschanged', handleVoices);
              applyFemaleVoice();
              speakGreeting();
            }, 600);
          }
        } catch (err) {
          console.warn('Speech synthesis greeting failed:', err);
          setIntroPlaying(false);
        }
      } else {
        setIntroPlaying(false);
      }
    }
    return () => {
      if (typeof window !== 'undefined' && window.speechSynthesis) {
        try { window.speechSynthesis.cancel(); } catch { }
      }
    };
  }, [userId, userName]);

  const displayName = (localStorage.getItem('neuro_display_name') || userName || '').trim();
  const firstName = displayName
    ? (displayName.includes('@') ? displayName.split('@')[0] : displayName.split(' ')[0])
    : 'there';

  const navProps = {
    user: {
      name: userName,
      displayName,
      email: userName,
      role: userDetails?.role || localStorage.getItem('neuro_user_role') || 'Individual',
    },
    isAuthenticated: Boolean(userId),
    onRequireLogin: () => {
      setLoginRedirectMsg('You should be logged in before using chat or uploading a file');
      setShowLoginModal(true);
    },
    onLogout: handleLogout,
    onDeactivate: () => setShowDeleteModal(true),
    onOpenSubscription: () => {
      const role =
        userDetails?.role ||
        userDetails?.user_role ||
        localStorage.getItem('neuro_user_role') ||
        'Individual';
      setSubscriptionPlan(getFirstPlanForRole(role));
      setShowSubscriptionModal(true);
    },
  };

  const requireAuthenticatedAction = (action) => {
    if (!userId) {
      setLoginRedirectMsg('Please log in to use this feature.');
      setShowLoginModal(true);
      return;
    }
    action();
  };

  const isRoleWorkspace =
    location.pathname === '/dashboard/take-care-agency' ||
    isHospitalDoctor ||
    isDoctor ||
    isHospitalAdmin ||
    isSchoolAdmin ||
    isCorporateAdmin ||
    (isTakeCareAgency && Boolean(userId));

  const roleDashboard =
    location.pathname === '/dashboard/take-care-agency' && userId ? (
      <TakeCareAgencyDashboard />
    ) : isHospitalDoctor ? (
      <HospitalDoctorDashboard />
    ) : isDoctor ? (
      <DoctorDashboard />
    ) : isHospitalAdmin ? (
      <HospitalDashboard />
    ) : isSchoolAdmin ? (
      <SchoolUniversityHome userDetails={userDetails} />
    ) : isCorporateAdmin ? (
      <CorporateDashboard userDetails={userDetails} />
    ) : (
      <TakeCareAgencyDashboard />
    );

  const features = [
    { key: 'track', icon: LuChartColumn, label: t('Track Your Emotions') },
    { key: 'insights', icon: LuBrainCircuit, label: t('Personalised Insights') },
    { key: 'companion', icon: LuFlower2, label: t('AI Companion ( Xi )') },
    { key: 'wellbeing', icon: LuTrendingUp, label: t('Improve Your Wellbeing') },
  ];

  const overlays = (
    <>
      <audio id="welcome-audio" autoPlay muted playsInline style={{ display: 'none' }} />

      <XiAssistant
        onSendVoice={assistantSendVoice}
        onCommand={handleBotCommand}
        isAuthenticated={Boolean(userId)}
        context={botContext}
        onRequireLogin={() => {
          setLoginRedirectMsg('You should be logged in before using chat or uploading a file');
          setShowLoginModal(true);
        }}
      />
      <LoginModal
        open={showLoginModal}
        onClose={() => {
          setShowLoginModal(false);
          setLoginRedirectMsg('');
        }}
        onLoginSuccess={handleLoginSuccess}
        redirectMsg={loginRedirectMsg ? <span className="login-redirect-msg">{loginRedirectMsg}</span> : undefined}
        initialEmail={(() => {
          if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('email') || '';
          }
          return '';
        })()}
      />
      <ConsultModal
        open={showConsultModal}
        onClose={() => setShowConsultModal(false)}
        onBooked={({ doctorName, date, time }) => {
          setConsultSuccessMsg(`Appointment booked with ${doctorName} on ${date} at ${time}.`);
          setShowConsultModal(false);
        }}
      />

      <UserDetailsModal
        open={userDetailsModalOpen}
        onClose={() => { setUserDetailsModalOpen(false); }}
        userDetails={userDetails}
        setUserDetails={setUserDetails}
        onOpenResetPassword={() => setShowResetPasswordModal(true)}
      />

      <DeleteAccountModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDeleteAccount={handleDeleteAccount}
      />

      <ResetPasswordModal
        open={showResetPasswordModal}
        onClose={() => setShowResetPasswordModal(false)}
      />

      <SubscriptionModal
        open={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
        userRole={
          userDetails?.role ||
          userDetails?.user_role ||
          localStorage.getItem('neuro_user_role') ||
          'Individual'
        }
        plan={subscriptionPlan}
        onUpgrade={() => {
          setShowSubscriptionModal(false);
          navigate('/plans');
        }}
      />

      <HelpDropdown open={showHelpModal} onClose={() => setShowHelpModal(false)} />
      <RingPairingModal
        open={showRingModal}
        onClose={() => setShowRingModal(false)}
        userId={userId}
        onPaired={(id) => { setRingPaired(true); setRingId(id); if (onRingPaired) onRingPaired(id); }}
        onUnpaired={() => { setRingPaired(false); setRingId(null); setSerialPort(null); setBleDevice(null); if (onRingUnpaired) onRingUnpaired(); }}
        onSerialConnected={(port) => { setSerialPort(port); if (onSerialConnected) onSerialConnected(port); }}
        onBLEConnected={(device) => { setBleDevice(device); setBleConnectKey(k => k + 1); }}
      />
      {ringPaired && bleDevice && !serialPort && (
        <RingAudioHandler
          userId={userId}
          bleDevice={bleDevice}
          bleConnectKey={bleConnectKey}
          onAudioReceived={(result) => {
            console.log('[Home] BLE audio processed:', result);
            setShowSaveSuccess(true);
            setTimeout(() => setShowSaveSuccess(false), 3000);
          }}
          onError={(error) => {
            console.error('[Home] BLE audio error:', error);
          }}
        />
      )}
    </>
  );

  return (
    <div className="home-page">
      {loading && <LoaderOverlay />}

      {isLoadingUserDetails && userId && !userDetails && (
        <div className="loader-overlay-gif">
          <div className="loader-lottie-container">
            <DotLottieReact
              src="https://lottie.host/137c3f68-7f71-4e2a-96c0-47a9a07c302c/0vmeyxWRaL.lottie"
              loop
              autoplay
              style={{ width: '200px', height: '200px' }}
            />
          </div>
          <div className="loader-message">Loading your dashboard... <br /> Please wait</div>
        </div>
      )}

      {isRoleWorkspace ? (
        <div className="xi-role-shell">
          <XiTopNav {...navProps} />
          <div className="xi-role-content">{roleDashboard}</div>
        </div>
      ) : (
        <div className="xi-app-frame">
          <XiBackdrop />
          <XiTopNav {...navProps} />

          <main className="xi-home">
            {consultSuccessMsg && (
              <div className="xi-notice xi-notice--success" role="status">
                <span>{consultSuccessMsg}</span>
                <button type="button" className="xi-btn xi-btn--soft" onClick={() => setConsultSuccessMsg('')}>
                  {t('Close')}
                </button>
              </div>
            )}

            {inviteInfo && inviteInfo.joinUrl && (
              <div className="xi-notice" role="status">
                <div>
                  <strong>{t('Incoming consultation')}</strong>
                  <span>
                    {inviteInfo.fromUser
                      ? `Doctor ${inviteInfo.fromUser} is ready to connect.`
                      : 'Your doctor is ready to begin the consultation.'}
                  </span>
                </div>
                <div className="xi-notice__actions">
                  <button
                    type="button"
                    className="xi-btn xi-btn--primary"
                    style={{ height: 40, padding: '0 18px', fontSize: '0.85rem' }}
                    onClick={() => {
                      try { window.open(inviteInfo.joinUrl, '_blank', 'noopener'); } catch { window.location.href = inviteInfo.joinUrl; }
                      dismissInvite();
                    }}
                  >
                    {t('Join Now')}
                  </button>
                  <button type="button" className="xi-btn xi-btn--soft" onClick={() => dismissInvite()}>
                    {t('Dismiss')}
                  </button>
                </div>
              </div>
            )}

            <section className="xi-hero">
              <div className="xi-hero__copy">
                <div className="xi-mobile-greeting">
                  {t('Hi')}, {firstName} <LuHand aria-hidden="true" />
                </div>

                <span className="xi-pill xi-hero__eyebrow">
                  <span className="xi-pill__dot" aria-hidden="true" />
                  {t('Wellbeing intelligence')}
                </span>

                <h1 className="xi-hero__title">
                  {t('Understand your')}
                  <br />
                  <em>{t('emotions, anytime')}</em>
                </h1>

                <p className="xi-hero__lede">
                  {t('Speak, chat and get real-time insights for a healthier, more balanced you')}
                </p>

                <div className="xi-hero__actions">
                  <button
                    type="button"
                    className="xi-btn xi-btn--primary"
                    onClick={() => {
                      setStartSignal((n) => n + 1);
                      const panel = document.getElementById('xi-emotion');
                      if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }}
                  >
                    <LuAudioLines aria-hidden="true" />
                    {t('Predict Emotion')}
                  </button>
                  <Link to="/chatbot" className="xi-btn xi-btn--ghost">
                    <LuMessageCircle aria-hidden="true" />
                    {t('Talk to Xi')}
                  </Link>
                </div>
              </div>

              <div className="xi-hero__visual">
                <div className="xi-bubble">
                  <span className="xi-bubble__hi">
                    {t('Hi')}, {firstName} <LuHand aria-hidden="true" />
                  </span>
                  <span className="xi-bubble__name">{t("I'm Xi!")}</span>
                  <span className="xi-bubble__text">
                    {t('Speak, chat, or check how you\u2019re feeling today.')}
                  </span>
                </div>

                <span className="xi-soundwave" aria-hidden="true">
                  <i /><i /><i /><i /><i /><i /><i /><i /><i />
                </span>

                <XiMascot state={loading ? 'thinking' : 'idle'} size="lg" />
              </div>
            </section>

            <section className="xi-emotion" id="xi-emotion" aria-label={t('Emotion prediction')}>
              <Recorder
                variant="xi"
                startSignal={startSignal}
                onResult={handleApiResult}
                onRecordingStart={handleRecordingStart}
                onAbort={() => setLoading(false)}
                onRequireLogin={() => {
                  setLoginRedirectMsg('You should be logged in before using chat or uploading a file');
                  setShowLoginModal(true);
                }}
                startRecordingRef={recorderStartRef}
              />
            </section>

            <section className="xi-support-actions" aria-label="Additional wellbeing services">
              <button
                type="button"
                className="xi-support-action xi-support-action--doctor"
                onClick={() => requireAuthenticatedAction(() => setShowConsultModal(true))}
              >
                <span className="xi-support-action__icon" aria-hidden="true">
                  <LuStethoscope />
                </span>
                <span className="xi-support-action__copy">
                  <strong>{t('Consult a Doctor')}</strong>
                  <span>{t('Book a session with a mental health professional')}</span>
                </span>
                <LuArrowRight className="xi-support-action__arrow" aria-hidden="true" />
              </button>
              <button
                type="button"
                className={`xi-support-action xi-support-action--ring${ringPaired ? ' is-paired' : ''}`}
                onClick={() => requireAuthenticatedAction(() => setShowRingModal(true))}
              >
                <span className="xi-support-action__icon" aria-hidden="true">
                  <LuBluetooth />
                </span>
                <span className="xi-support-action__copy">
                  <strong>{ringPaired ? t('Pi Ring Connected') : t('Pair Pi Ring')}</strong>
                  <span>{ringPaired ? t('Manage your connected device') : t('Connect USB or Bluetooth')}</span>
                </span>
                <LuArrowRight className="xi-support-action__arrow" aria-hidden="true" />
              </button>
            </section>

            <AnimatePresence>
              {!loading && emotionResult && (
                <motion.div
                  ref={reportRef}
                  className="xi-result-wrap"
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 12 }}
                  transition={{ duration: 0.35 }}
                >
                  <EmotionResultBox
                    result={emotionResult}
                    user={firstName}
                    onClose={() => setEmotionResult(null)}
                    onSaved={() => {
                      setEmotionResult(null);
                      setShowSaveSuccess(true);
                      setTimeout(() => setShowSaveSuccess(false), 3000);
                    }}
                  />
                </motion.div>
              )}
            </AnimatePresence>

            {showSaveSuccess && (
              <p className="xi-save-note" role="status">
                {t('Report saved to dashboard. Check in Dashboard.')}
              </p>
            )}

            <div className="xi-chat-cta-row">
              <Link to="/chatbot" className="xi-chat-cta">
                <span className="xi-chat-cta__avatar" aria-hidden="true">
                  <XiBotAvatar size="md" />
                </span>
                <span className="xi-chat-cta__icon" aria-hidden="true">
                  <LuMessageCircle />
                </span>
                {t('Speak to Chatbot')}
                <LuArrowRight className="xi-chat-cta__arrow" aria-hidden="true" />
              </Link>
            </div>

            <section className="xi-features" aria-label={t('What Xi does')}>
              {features.map((feature) => {
                const Icon = feature.icon;
                return (
                  <div className="xi-feature" key={feature.key}>
                    <span className="xi-feature__icon" aria-hidden="true">
                      <Icon />
                    </span>
                    <span className="xi-feature__label">{feature.label}</span>
                  </div>
                );
              })}
            </section>
          </main>

          <XiBottomNav />
        </div>
      )}

      {overlays}
    </div>
  );
}
